var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ele-form-dialog',{attrs:{"formDesc":_vm.formDesc,"labelPosition":"left","width":"800px","dialogAttrs":{
    'close-on-click-modal': false,
    'append-to-body': true
  },"visible":_vm.visible,"title":"批量添加表单项"},on:{"request":_vm.handleAdd,"update:visible":function($event){return _vm.$emit('change')}},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}})}
var staticRenderFns = []

export { render, staticRenderFns }